import styled from 'styled-components';

const LeaderboardItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export default LeaderboardItemHeader;
